const messages = {
  title: "PRODUCT Price Lists & Brochures",
  description:
    "Download the latest brochures and flyers about our Bridgestone and Firestone tires for passenger cars, SUVs, and vans here.",
  brochureCategories: {
    products: "Products",
    brand_and_solutions: "Brand and Solutions",
    season_and_promotions: "Season & Promotions",
    format: "Format",
    cars_and_vans: "Passenger Car & Van",
    summer: "Summer",
    winter: "Winter",
    promotions: "Promotions",
    all_season: "All Season",
    truck_and_buses: "Trucks & Buses",
    motorcycle: "Motorcycle",
    agriculture: "Agriculture",
    construction_machinery: "Construction Machinery",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materials",
    brochures: "Product Brochures",
    price_list: "Price Lists",
    materials: "Materials",
    video_in_store: "Video with subtitles",
    video_online: "Video without subtitles",
    banner_website: "Banner",
    banner_social_media: "Social Media",
    logos: "Logos",
  },
  searchMedia: "Enter keyword",
  searchResults: "Search Results",
};

export default {
  messages,
};
